<script lang="ts" setup>
  import { RouteLocation } from 'vue-router'
  import { storeToRefs } from 'pinia'
  import { definePageMeta } from '#imports'
  import { useGameContentStore } from '~/store/GameContent'
  import { RouteRecordParam } from '~/model/RouteRecord/RouteRecord'
  import { ContentPageId } from '~/model/ContentPage/ContentPage'
  import useRouteRecord from '~/composables/RouteRecord/RouteRecord'

  const gameContentStore = useGameContentStore()

  const { pageContent } = storeToRefs(gameContentStore)
  const { pageParam } = useRouteRecord()

  const pageId = pageParam.value as ContentPageId

  definePageMeta({
    key: (route: RouteLocation) => route.fullPath,
    layout: 'content-with-navigation',
    middleware: ['page'],
  })
</script>

<template>
  <div
    class="c-page s-page s-page--fill u-typography-root u-typography-root--visual-theme-negative"
  >
    <div class="c-page__main">
      <ContentPageBody v-if="pageContent" :key="pageId" :content="pageContent" />
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
